import { AppBar, Toolbar } from "@mui/material";
import { styled } from "styled-components";

export const MenuHeaderContainer = styled("div")({ height: "7.5rem", zIndex: "2" });

export const MenuAppBar = styled(AppBar)<{ $appBarTransition: string; $isPublicPageTab: boolean }>(
  ({ $appBarTransition, $isPublicPageTab }) => ({
    height: "40px",
    "&.MuiAppBar-root": {
      backgroundColor: "transparent",
      transition: $appBarTransition,
    },
    ...($isPublicPageTab && {
      boxShadow: "none",
      pointerEvents: "none",
    }),
  }),
);

export const MenuUpperToolbar = styled(Toolbar)<{ $hasTabStatus: boolean }>(({ $hasTabStatus }) => ({
  minHeight: "40px",
  backgroundColor: "#505050",
  justifyContent: "space-between",
  marginTop: $hasTabStatus ? "40px" : "0",
  "&.MuiToolbar-root": {
    padding: "0px 16px",
  },
}));

export const HeaderTitleSection = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  flex: 1,
  "@media (max-width:767px)": {
    flex: "0 0 50%",
    maxWidth: "50%",
  },
});

export const HeaderMenuSection = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  "@media (max-width:767px)": {
    flex: "0 0 50%",
    maxWidth: "50%",
    order: 3,
    justifyContent: "center",
  },
});

export const HeaderIconSection = styled("div")({ flex: 1 });
